import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
    routes: [
      {
        path: '/',
        name: 'home',
        component: () => import('./pages/home/index.vue'),
        meta : {
          public: true
        }
      },
      {
        path: '*',
        name: '404',
        component: () => import('./pages/404.vue')
      }
    ]
})

export default router